var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachmentwebadmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2074_20637",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2074_20637)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2074_20637",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2074_20637)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25323 10.4961V6.00083C7.25323 5.72469 7.02937 5.50083 6.75323 5.50083C6.47709 5.50083 6.25323 5.72469 6.25323 6.00083V10.4961C6.26083 10.9799 6.43516 11.3896 6.7762 11.7253C7.11724 12.061 7.52704 12.2289 8.00558 12.2289C8.48412 12.2289 8.89391 12.061 9.23495 11.7253C9.576 11.3896 9.7503 10.9825 9.75786 10.504L9.76198 4.6043C9.77082 3.87758 9.51852 3.25437 9.00506 2.73466C8.49161 2.21494 7.86959 1.95508 7.13901 1.95508C6.40844 1.95508 5.78643 2.21494 5.27297 2.73466C4.75952 3.25438 4.50723 3.8795 4.51609 4.61002L4.51605 10.5358C4.50201 11.503 4.8362 12.3328 5.51861 13.0252C6.20102 13.7175 7.02829 14.0637 8.00042 14.0637C8.97256 14.0637 9.79983 13.7175 10.4822 13.0252C11.1647 12.3328 11.4988 11.5006 11.4847 10.5286L11.4848 4.9927C11.4848 4.71656 11.2609 4.4927 10.9848 4.4927C10.7087 4.4927 10.4848 4.71656 10.4848 4.9927L10.4849 10.5431C10.4949 11.2362 10.2566 11.8295 9.77003 12.3232C9.28345 12.8169 8.69358 13.0637 8.00042 13.0637C7.30726 13.0637 6.71739 12.8169 6.23081 12.3232C5.74424 11.8295 5.50598 11.2337 5.51605 10.5358L5.51601 4.59789C5.51053 4.14586 5.66664 3.75905 5.98436 3.43746C6.30207 3.11587 6.68695 2.95508 7.13901 2.95508C7.59108 2.95508 7.97597 3.11587 8.29368 3.43746C8.61139 3.75905 8.76749 4.14777 8.76198 4.60361L8.75798 10.4882C8.75474 10.6937 8.67989 10.8685 8.53345 11.0126C8.38701 11.1568 8.21106 11.2289 8.00558 11.2289C7.8001 11.2289 7.62414 11.1568 7.4777 11.0126C7.33126 10.8685 7.25644 10.6963 7.25323 10.4961Z",
    fill: "#9CA3AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentwebadmin);
export default __webpack_public_path__ + "static/media/attachmentwebadmin.20e7e9b6d0289db5cc85e9d840b1bfdf.svg";
export { ForwardRef as ReactComponent };